"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootRenderTokensHost = void 0;
var react_1 = __importDefault(require("react"));
var RenderTokensHost_1 = require("./RenderTokensHost");
var hydrationHelpers_1 = require("@CommonFrontend/Public/Widgets/hydrationHelpers");
var PublicStyleContext_1 = require("./PublicStyleContext");
var RenderTokensHostContext_1 = require("./RenderTokensHostContext");
var PublicPrintContext_1 = require("./PublicPrintContext");
var ImgixContext_1 = require("./ImgixContext");
var PublicPageContext_1 = require("./PublicPageContext");
var RootRenderTokensHost = function (_a) {
    var tokens = _a.tokens, blockStyles = _a.blockStyles, allColors = _a.allColors, imgixContext = _a.imgixContext, printContext = _a.printContext, publicPageContext = _a.publicPageContext;
    return (react_1.default.createElement(RenderTokensHostContext_1.RenderTokensHostContextProvider, { RenderTokensHost: RenderTokensHost_1.RenderTokensHost },
        react_1.default.createElement(PublicStyleContext_1.PublicStyleContextProvider, { blockStyles: blockStyles, allColors: allColors },
            react_1.default.createElement(PublicPrintContext_1.PublicPrintContextProvider, __assign({}, printContext),
                react_1.default.createElement(ImgixContext_1.ImgixContextProvider, __assign({}, imgixContext),
                    react_1.default.createElement(PublicPageContext_1.PublicPageContextProvider, __assign({}, publicPageContext),
                        react_1.default.createElement(RenderTokensHost_1.RenderTokensHost, { tokens: tokens })))))));
};
exports.RootRenderTokensHost = RootRenderTokensHost;
exports.default = (0, hydrationHelpers_1.withHydrationHost)(RootRenderTokensHost, {
    componentName: "HydratableRootRenderTokensHost",
});
